import { Component } from '@angular/core';
import { PillarPagesTemp } from '../../components/pillar-pages-temp/pillar-pages-temp';

@Component({
  selector: 'app-ctso',
  imports: [PillarPagesTemp],
  templateUrl: './ctso.html',
  styleUrl: './ctso.scss',
})
export class Ctso {

}
